import { createQueryString } from '@eika-infrastruktur/utils';

import type {
    AvtalegiroAgreement,
    AvtalegiroAgreementRequest,
    PaymentAgreementId,
    AvtalegiroAgreementDetails,
    ApprovalResult,
    AvtalegiroProposal,
    AvtaleGiroProposalId,
    DynamicLinkId,
    ExternalAvtalegiro,
    MoveExternalAvtalegiros,
    MoveExternalAvtalegirosResult,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { del, get, post, put } from './request';

const SERVICE_PATH = 'rest/resource/avtalegiro';

export function getAvtaleGiro(): Promise<AvtalegiroAgreement[]> {
    return get<AvtalegiroAgreement[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export function getAvtaleGiroProposals(): Promise<AvtalegiroProposal[]> {
    return get<AvtalegiroProposal[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/proposals`);
}

export function getAvtaleGiroDetails(paymentAgreementId: PaymentAgreementId): Promise<AvtalegiroAgreementDetails> {
    return get<AvtalegiroAgreementDetails>(`${CONTEXT_PATH}/${SERVICE_PATH}/${paymentAgreementId}`);
}

export function createAvtaleGiroAgreement(
    avtalegiroAgreementRequest: AvtalegiroAgreementRequest,
): Promise<ApprovalResult> {
    return post<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}`, avtalegiroAgreementRequest);
}

export function deleteAvtaleGiroAgreement(avtalegiroId: PaymentAgreementId): Promise<ApprovalResult> {
    const queryString = createQueryString({
        deviceId: window.ReactNativeProps?.deviceId,
    });

    return del(`${CONTEXT_PATH}/${SERVICE_PATH}/${avtalegiroId}${queryString}`);
}

export function createAvtalgiroProposal(
    proposalId: AvtaleGiroProposalId,
    avtalegiro: AvtalegiroAgreementRequest,
): Promise<ApprovalResult> {
    return post<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/proposal/${proposalId}`, avtalegiro);
}

export function deleteAvtalegiroProposal(proposalId: AvtaleGiroProposalId): Promise<ApprovalResult> {
    return del(`${CONTEXT_PATH}/${SERVICE_PATH}/proposals/${proposalId}`);
}

export function updateAvtaleGiroAgreement(
    avtalegiroUpdate: AvtalegiroAgreementRequest,
    avtalegiroId: PaymentAgreementId,
): Promise<ApprovalResult> {
    return put<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/${avtalegiroId}`, avtalegiroUpdate);
}

export const startAvtalegiroMove = (): Promise<ApprovalResult> => {
    const queryString = createQueryString({
        deviceId: window.ReactNativeProps?.deviceId,
    });
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/external${queryString}`);
};

export const listExternalAvtalegiros = (dynamicLinkId: DynamicLinkId) => {
    return get<ExternalAvtalegiro[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/external/${dynamicLinkId.value}`);
};

export const moveAvtalegiros = (dynamicLinkId: DynamicLinkId) => (request: MoveExternalAvtalegiros) => {
    return post<MoveExternalAvtalegirosResult[]>(
        `${CONTEXT_PATH}/${SERVICE_PATH}/external/${dynamicLinkId.value}`,
        request,
    );
};
